import {UIFilter} from './UIfilter'
(function(){
    const $uiFilters = document.querySelectorAll('.ui-filter')
    $uiFilters.forEach($f => new UIFilter.Filter($f).init())
    const $uiFilterSelections = document.querySelectorAll('.ui-filter-selection')
    $uiFilterSelections.forEach($fS => new UIFilter.FilterSelection($fS).init())
})()